import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-hrsection-create',
  templateUrl: './hrsection-create.component.html',
  styleUrls: ['./hrsection-create.component.scss']
})
export class HrsectionCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];

      console.log(`${id}`);
      this.http.get<any>(this.api_endpoint + '/homeranksectionbyid/' + `${id}`).subscribe(
        data => {
          console.log(data.data);
          if (data.data != null) {
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              heading: data.data.heading,
              description: data.data.description,
              seohidden: data.data.seohidden,

              title1: data.data.title1,

              title1_sub1: data.data.title1_sub1,
              title1_sub2: data.data.title1_sub2,
              title1_sub3: data.data.title1_sub3,
              title1_sub4: data.data.title1_sub4,
              title1_des1: data.data.title1_des1,
              title1_des2: data.data.title1_des2,
              title1_des3: data.data.title1_des3,
              title1_des4: data.data.title1_des4,
              title1_img1: data.data.title1_img1,
              title1_img2: data.data.title1_img2,
              title1_img3: data.data.title1_img3,
              title1_img4: data.data.title1_img4,
              title1_alt1: data.data.title1_alt1,
              title1_alt2: data.data.title1_alt2,
              title1_alt3: data.data.title1_alt3,
              title1_alt4: data.data.title1_alt4,

              title2: data.data.title2,

              title2_sub1: data.data.title2_sub1,
              title2_sub2: data.data.title2_sub2,
              title2_sub3: data.data.title2_sub3,
              title2_sub4: data.data.title2_sub4,
              title2_sub5: data.data.title2_sub5,
              title2_sub6: data.data.title2_sub6,
              title2_desc1: data.data.title2_desc1,
              title2_desc2: data.data.title2_desc2,
              title2_desc3: data.data.title2_desc3,
              title2_btn1: data.data.title2_btn1,
              title2_btn2: data.data.title2_btn2,
              title2_btn3: data.data.title2_btn3,
              title2_btn1_url: data.data.title2_btn1_url,
              title2_btn2_url: data.data.title2_btn2_url,
              title2_btn3_url: data.data.title2_btn3_url,

              title3: data.data.title3,

              title3_desc: data.data.title3_desc,
              title3_sub1: data.data.title3_sub1,
              title3_sub2: data.data.title3_sub2,
              title3_sub3: data.data.title3_sub3,
              title3_sub4: data.data.title3_sub4,
              title3_img1: data.data.title3_img1,
              title3_img2: data.data.title3_img2,
              title3_img3: data.data.title3_img3,
              title3_img4: data.data.title3_img4,
              title3_alt1: data.data.title3_alt1,
              title3_alt2: data.data.title3_alt2,
              title3_alt3: data.data.title3_alt3,
              title3_alt4: data.data.title3_alt4,
              title3_btn1: data.data.title3_btn1,
              title3_btn2: data.data.title3_btn2,
              title3_btn3: data.data.title3_btn3,
              title3_btn4: data.data.title3_btn4,
              title3_btn1_url: data.data.title3_btn1_url,
              title3_btn2_url: data.data.title3_btn2_url,
              title3_btn3_url: data.data.title3_btn3_url,
              title3_btn4_url: data.data.title3_btn4_url,

              title4: data.data.title4,

              title4_desc1: data.data.title4_desc1,
              title4_desc2: data.data.title4_desc2,
              title4_btn1: data.data.title4_btn1,
              title4_btn1_url: data.data.title4_btn1_url,

              title5: data.data.title5,

              title5_desc1: data.data.title5_desc1,
              title5_desc2: data.data.title5_desc2,
              title5_sub1: data.data.title5_sub1,
              title5_sub2: data.data.title5_sub2,
              title5_btn1: data.data.title5_btn1,
              title5_btn2: data.data.title5_btn2,
              title5_btn3: data.data.title5_btn3,
              title5_btn4: data.data.title5_btn4,
              title5_btn1_url: data.data.title5_btn1_url,
              title5_btn2_url: data.data.title5_btn2_url,
              title5_btn3_url: data.data.title5_btn3_url,
              title5_btn4_url: data.data.title5_btn4_url,
              title5_img1: data.data.title5_img1,
              title5_img2: data.data.title5_img2,
              title5_alt1: data.data.title5_alt1,
              title5_alt2: data.data.title5_alt2,
              title5_desc3: data.data.title5_desc3,
              title5_sub3: data.data.title5_sub3,
              title6: data.data.title6,
              title6_sub1: data.data.title6_sub1,
              title6_desc: data.data.title6_desc,
              title7: data.data.title7,
              title7_sub1: data.data.title7_sub1,
              title7_desc: data.data.title7_desc,
              title8: data.data.title8,
              title8_sub1: data.data.title8_sub1,
              title8_desc: data.data.title8_desc,
              title9: data.data.title9,
              title9_desc: data.data.title9_desc,
              title9_btn: data.data.title9_btn,
              title9_btn_url: data.data.title9_btn_url,
            });
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    });

    this.Form = this.formBuilder.group({
      heading: ['', Validators.required],
      description: ['', Validators.required],
      _id: [''],
      seohidden: [''],
      title1: [''],
      title1_sub1: [''],
      title1_sub2: [''],
      title1_sub3: [''],
      title1_sub4: [''],

      title1_des1: [''],
      title1_des2: [''],
      title1_des3: [''],
      title1_des4: [''],

      title1_img1: [''],
      title1_img2: [''],
      title1_img3: [''],
      title1_img4: [''],

      title1_alt1: [''],
      title1_alt2: [''],
      title1_alt3: [''],
      title1_alt4: [''],

      title2: [''],
      title2_sub1: [''],
      title2_sub2: [''],
      title2_sub3: [''],
      title2_sub4: [''],
      title2_sub5: [''],
      title2_sub6: [''],

      title2_desc1: [''],
      title2_desc2: [''],
      title2_desc3: [''],

      title2_btn1: [''],
      title2_btn2: [''],
      title2_btn3: [''],
      title2_btn1_url: [''],
      title2_btn2_url: [''],
      title2_btn3_url: [''],

      title3: [''],
      title3_desc: [''],
      title3_sub1: [''],
      title3_sub2: [''],
      title3_sub3: [''],
      title3_sub4: [''],


      title3_img1: [''],
      title3_img2: [''],
      title3_img3: [''],
      title3_img4: [''],

      title3_alt1: [''],
      title3_alt2: [''],
      title3_alt3: [''],
      title3_alt4: [''],

      title3_btn1: [''],
      title3_btn2: [''],
      title3_btn3: [''],
      title3_btn4: [''],
      title3_btn1_url: [''],
      title3_btn2_url: [''],
      title3_btn3_url: [''],
      title3_btn4_url: [''],

      title4: [''],
      title4_desc1: [''],
      title4_desc2: [''],
      title4_btn1: [''],
      title4_btn1_url: [''],

      title5: [''],
      title5_desc1: [''],
      title5_desc2: [''],
      title5_sub1: [''],
      title5_sub2: [''],

      title5_btn1: [''],
      title5_btn2: [''],
      title5_btn3: [''],
      title5_btn4: [''],
      title5_btn1_url: [''],
      title5_btn2_url: [''],
      title5_btn3_url: [''],
      title5_btn4_url: [''],

      title5_img1: [''],
      title5_img2: [''],

      title5_alt1: [''],
      title5_alt2: [''],
      title5_sub3: [''],
      title5_desc3: [''],
      title6: [''],
      title6_sub1: [''],
      title6_desc: [''],
      title7: [''],
      title7_sub1: [''],
      title7_desc: [''],
      title8: [''],
      title8_sub1: [''],
      title8_desc: [''],
      title9: [''],
      title9_desc: [''],
      title9_btn: [''],
      title9_btn_url: [''],

    })

  }

  get f() { return this.Form.controls; }

  onFormSubmit() {

    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == 'Submit') {

      var data = {
        "heading": this.Form.value.heading,
        "description": this.Form.value.description,
        "admin": sessionStorage.getItem('adminName'),
        "seohidden": this.Form.value.seohidden,

        "title1": this.Form.value.title1,

        "title1_sub1": this.Form.value.title1_sub1,
        "title1_sub2": this.Form.value.title1_sub2,
        "title1_sub3": this.Form.value.title1_sub3,
        "title1_sub4": this.Form.value.title1_sub4,

        "title1_des1": this.Form.value.title1_des1,
        "title1_des2": this.Form.value.title1_des2,
        "title1_des3": this.Form.value.title1_des3,
        "title1_des4": this.Form.value.title1_des4,

        "title1_img1": this.Form.value.title1_img1,
        "title1_img2": this.Form.value.title1_img2,
        "title1_img3": this.Form.value.title1_img3,
        "title1_img4": this.Form.value.title1_img4,

        "title1_alt1": this.Form.value.title1_alt1,
        "title1_alt2": this.Form.value.title1_alt2,
        "title1_alt3": this.Form.value.title1_alt3,
        "title1_alt4": this.Form.value.title1_alt4,

        "title2": this.Form.value.title2,

        "title2_sub1": this.Form.value.title2_sub1,
        "title2_sub2": this.Form.value.title2_sub2,
        "title2_sub3": this.Form.value.title2_sub3,
        "title2_sub4": this.Form.value.title2_sub4,
        "title2_sub5": this.Form.value.title2_sub5,
        "title2_sub6": this.Form.value.title2_sub6,

        "title2_desc1": this.Form.value.title2_desc1,
        "title2_desc2": this.Form.value.title2_desc2,
        "title2_desc3": this.Form.value.title2_desc3,

        'title2_btn1': this.Form.value.title2_btn1,
        "title2_btn2": this.Form.value.title2_btn2,
        "title2_btn3": this.Form.value.title2_btn3,
        "title2_btn1_url": this.Form.value.title2_btn1_url,
        "title2_btn2_url": this.Form.value.title2_btn2_url,
        "title2_btn3_url": this.Form.value.title2_btn3_url,

        "title3": this.Form.value.title3,

        "title3_desc": this.Form.value.title3_desc,
        "title3_sub1": this.Form.value.title3_sub1,
        'title3_sub2': this.Form.value.title3_sub2,
        "title3_sub3": this.Form.value.title3_sub3,
        'title3_sub4': this.Form.value.title3_sub4,


        "title3_img1": this.Form.value.title3_img1,
        "title3_img2": this.Form.value.title3_img2,
        "title3_img3": this.Form.value.title3_img3,
        "title3_img4": this.Form.value.title3_img4,

        'title3_alt1': this.Form.value.title3_alt1,
        "title3_alt2": this.Form.value.title3_alt2,
        "title3_alt3": this.Form.value.title3_alt3,
        'title3_alt4': this.Form.value.title3_alt4,

        "title3_btn1": this.Form.value.title3_btn1,
        "title3_btn2": this.Form.value.title3_btn2,
        'title3_btn3': this.Form.value.title3_btn3,
        "title3_btn4": this.Form.value.title3_btn4,
        "title3_btn1_url": this.Form.value.title3_btn1_url,
        "title3_btn2_url": this.Form.value.title3_btn2_url,
        "title3_btn3_url": this.Form.value.title3_btn3_url,
        "title3_btn4_url": this.Form.value.title3_btn4_url,

        "title4": this.Form.value.title4,

        "title4_desc1": this.Form.value.title4_desc1,
        "title4_desc2": this.Form.value.title4_desc2,
        "title4_btn1": this.Form.value.title4_btn1,
        "title4_btn1_url": this.Form.value.title4_btn1_url,

        "title5": this.Form.value.title5,

        "title5_desc1": this.Form.value.title5_desc1,
        "title5_desc2": this.Form.value.title5_desc2,
        "title5_sub1": this.Form.value.title5_sub1,
        'title5_sub2': this.Form.value.title5_sub2,

        "title5_btn1": this.Form.value.title5_btn1,
        "title5_btn2": this.Form.value.title5_btn2,
        "title5_btn3": this.Form.value.title5_btn3,
        "title5_btn4": this.Form.value.title5_btn4,
        "title5_btn1_url": this.Form.value.title5_btn1_url,
        "title5_btn2_url": this.Form.value.title5_btn2_url,
        'title5_btn3_url': this.Form.value.title5_btn3_url,
        "title5_btn4_url": this.Form.value.title5_btn4_url,

        "title5_img1": this.Form.value.title5_img1,
        "title5_img2": this.Form.value.title5_img2,

        "title5_alt1": this.Form.value.title5_alt1,
        "title5_alt2": this.Form.value.title5_alt2,
        "title5_desc3": this.Form.value.title5_desc3,
        "title5_sub3": this.Form.value.title5_sub3,
        "title6": this.Form.value.title6,
        "title6_sub1": this.Form.value.title6_sub1,
        "title6_desc": this.Form.value.title6_desc,
        "title7": this.Form.value.title7,
        "title7_sub1": this.Form.value.title7_sub1,
        "title7_desc": this.Form.value.title7_desc,
        "title8": this.Form.value.title8,
        "title8_sub1": this.Form.value.title8_sub1,
        "title8_desc": this.Form.value.title8_desc,
        "title9": this.Form.value.title9,
        "title9_desc": this.Form.value.title9_desc,
        "title9_btn": this.Form.value.title9_btn,
        "title9_btn_url": this.Form.value.title9_btn_url,

      };
      console.log(data);
      this.http.post<any>(this.api_endpoint + '/homeranksection', data).subscribe(
        res => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          } else {
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          }
          this.router.navigateByUrl('/adminhkbkcms/homeranksection/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    } else {
      var data1 = {
        "heading": this.Form.value.heading,
        "description": this.Form.value.description,
        "admin": sessionStorage.getItem('adminName'),
        "_id": this.Form.value._id,
        "seohidden": this.Form.value.seohidden,

        "title1": this.Form.value.title1,

        "title1_sub1": this.Form.value.title1_sub1,
        "title1_sub2": this.Form.value.title1_sub2,
        "title1_sub3": this.Form.value.title1_sub3,
        "title1_sub4": this.Form.value.title1_sub4,

        "title1_des1": this.Form.value.title1_des1,
        "title1_des2": this.Form.value.title1_des2,
        "title1_des3": this.Form.value.title1_des3,
        "title1_des4": this.Form.value.title1_des4,

        "title1_img1": this.Form.value.title1_img1,
        "title1_img2": this.Form.value.title1_img2,
        "title1_img3": this.Form.value.title1_img3,
        "title1_img4": this.Form.value.title1_img4,

        "title1_alt1": this.Form.value.title1_alt1,
        "title1_alt2": this.Form.value.title1_alt2,
        "title1_alt3": this.Form.value.title1_alt3,
        "title1_alt4": this.Form.value.title1_alt4,

        "title2": this.Form.value.title2,

        "title2_sub1": this.Form.value.title2_sub1,
        "title2_sub2": this.Form.value.title2_sub2,
        "title2_sub3": this.Form.value.title2_sub3,
        "title2_sub4": this.Form.value.title2_sub4,
        "title2_sub5": this.Form.value.title2_sub5,
        "title2_sub6": this.Form.value.title2_sub6,

        "title2_desc1": this.Form.value.title2_desc1,
        "title2_desc2": this.Form.value.title2_desc2,
        "title2_desc3": this.Form.value.title2_desc3,

        'title2_btn1': this.Form.value.title2_btn1,
        "title2_btn2": this.Form.value.title2_btn2,
        "title2_btn3": this.Form.value.title2_btn3,
        "title2_btn1_url": this.Form.value.title2_btn1_url,
        "title2_btn2_url": this.Form.value.title2_btn2_url,
        "title2_btn3_url": this.Form.value.title2_btn3_url,

        "title3": this.Form.value.title3,

        "title3_desc": this.Form.value.title3_desc,
        "title3_sub1": this.Form.value.title3_sub1,
        'title3_sub2': this.Form.value.title3_sub2,
        "title3_sub3": this.Form.value.title3_sub3,
        'title3_sub4': this.Form.value.title3_sub4,


        "title3_img1": this.Form.value.title3_img1,
        "title3_img2": this.Form.value.title3_img2,
        "title3_img3": this.Form.value.title3_img3,
        "title3_img4": this.Form.value.title3_img4,

        'title3_alt1': this.Form.value.title3_alt1,
        "title3_alt2": this.Form.value.title3_alt2,
        "title3_alt3": this.Form.value.title3_alt3,
        'title3_alt4': this.Form.value.title3_alt4,

        "title3_btn1": this.Form.value.title3_btn1,
        "title3_btn2": this.Form.value.title3_btn2,
        'title3_btn3': this.Form.value.title3_btn3,
        "title3_btn4": this.Form.value.title3_btn4,
        "title3_btn1_url": this.Form.value.title3_btn1_url,
        "title3_btn2_url": this.Form.value.title3_btn2_url,
        "title3_btn3_url": this.Form.value.title3_btn3_url,
        "title3_btn4_url": this.Form.value.title3_btn4_url,

        "title4": this.Form.value.title4,

        "title4_desc1": this.Form.value.title4_desc1,
        "title4_desc2": this.Form.value.title4_desc2,
        "title4_btn1": this.Form.value.title4_btn1,
        "title4_btn1_url": this.Form.value.title4_btn1_url,

        "title5": this.Form.value.title5,

        "title5_desc1": this.Form.value.title5_desc1,
        "title5_desc2": this.Form.value.title5_desc2,
        "title5_sub1": this.Form.value.title5_sub1,
        'title5_sub2': this.Form.value.title5_sub2,

        "title5_btn1": this.Form.value.title5_btn1,
        "title5_btn2": this.Form.value.title5_btn2,
        "title5_btn3": this.Form.value.title5_btn3,
        "title5_btn4": this.Form.value.title5_btn4,
        "title5_btn1_url": this.Form.value.title5_btn1_url,
        "title5_btn2_url": this.Form.value.title5_btn2_url,
        'title5_btn3_url': this.Form.value.title5_btn3_url,
        "title5_btn4_url": this.Form.value.title5_btn4_url,

        "title5_img1": this.Form.value.title5_img1,
        "title5_img2": this.Form.value.title5_img2,

        "title5_alt1": this.Form.value.title5_alt1,
        "title5_alt2": this.Form.value.title5_alt2,
        "title5_desc3": this.Form.value.title5_desc3,
        "title5_sub3": this.Form.value.title5_sub3,
        "title6": this.Form.value.title6,
        "title6_sub1": this.Form.value.title6_sub1,
        "title6_desc": this.Form.value.title6_desc,
        "title7": this.Form.value.title7,
        "title7_sub1": this.Form.value.title7_sub1,
        "title7_desc": this.Form.value.title7_desc,
        "title8": this.Form.value.title8,
        "title8_sub1": this.Form.value.title8_sub1,
        "title8_desc": this.Form.value.title8_desc,
        "title9": this.Form.value.title9,
        "title9_desc": this.Form.value.title9_desc,
        "title9_btn": this.Form.value.title9_btn,
        "title9_btn_url": this.Form.value.title9_btn_url,

      };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint + '/homeranksection/', data1).subscribe(
        res => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          } else {
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          }
          this.router.navigateByUrl('/adminhkbkcms/homeranksection/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
